import React, { useMemo } from 'react';
import { Button } from 'react-bootstrap';
import { getActionsModel } from '../../../services/roles/factdataRoleStatus';
import TableAction from '../../strategyProject/tabs/TabResults/TableAction/TableAction';
import componentStyles from '../../strategyProject/tabs/TabResults/TabResults.module.less';
import { Tooltip } from '@material-ui/core';
import { History } from '@material-ui/icons';

export const ReceiptsActions = ({ props, actions, userCtx, stratId, policyId, portfId, isProgram, isInsideTabs, roleModel, ...rest }) => {
  const { status, statusNew, projId, style } = props;
  const whichStatus = statusNew ? statusNew : status;
  const can = useMemo(() => getActionsModel(status, userCtx, stratId, portfId, projId, policyId), [props, userCtx, stratId, portfId, policyId]);
  const isTableActionEnabled = useMemo(() => (can.Send || can.Edit || can.Approve || can.Reject || can.Delete || can.Exclude || roleModel.canEdit || roleModel.canDelete), [can]);
  
  return (
    <div className='d-flex gap-2 align-items-center'>
      {actions.checkHistory && <Tooltip title='История изменений'>
        <History style={{ color: '#0D6EFD', cursor: 'pointer' }} onClick={() => actions.checkHistory(props)}/>
      </Tooltip>}
      {
        (isTableActionEnabled && isProgram ?
          (<TableAction width="350px" style={style} data={props.data} actionsDisabled={!isTableActionEnabled}>
            { can.Edit && (
            <Button
              style={{ width: '100%' }}
              className={componentStyles.actionTableButton}
              onClick={() => actions.edit(props)}
              variant="primary"
            >
              Редактировать
            </Button>
            )}
            { can.Approve && (
            <Button
              className={componentStyles.actionTableButton}
              onClick={() => actions.approve(props)}
              variant="outline-success"
            >
              Согласовать
            </Button>
            )}
            { can.Reject && (
            <Button
              className={componentStyles.actionTableButton}
              onClick={() => actions.reject(props)}
              variant="outline-danger"
            >
              Не согласовать
            </Button>
            )}
          </TableAction>)
          : isTableActionEnabled ? 
          ( <TableAction width="350px" style={style} data={props.data} actionsDisabled={!isTableActionEnabled}>
            { can.Send && (
            <Button
              className={componentStyles.actionTableButton}
              onClick={() => actions.send(props)}
              variant="outline-warning"
            >
              Отправить на согласование
            </Button>
            )}
            { ((can.Edit && !isInsideTabs) || (isInsideTabs && roleModel?.canEdit)) && (
            <Button
              style={{ width: '100%' }}
              className={componentStyles.actionTableButton}
              onClick={() => actions.edit(props)}
              variant="primary"
            >
              Редактировать
            </Button>
            )}
            { can.Approve && (
            <Button
              className={componentStyles.actionTableButton}
              onClick={() => actions.approve(props)}
              variant="outline-success"
            >
              Согласовать
            </Button>
            )}
            { can.Reject && (
            <Button
              className={componentStyles.actionTableButton}
              onClick={() => actions.reject(props)}
              variant="outline-danger"
            >
              Не согласовать
            </Button>
            )}
            { whichStatus === 'created' && (
            <Button
              className={componentStyles.actionTableButton}
              onClick={() => actions.exclude(props)}
              variant="outline-danger"
            >
              Не относить к проекту
            </Button>
            )}
            { whichStatus === 'excluded' && (
            <Button
              className={componentStyles.actionTableButton}
              onClick={() => actions.return(props)}
              variant="primary"
            >
              Вернуть в статус "Новый"
            </Button>
            )}
            { ((can.See && !isInsideTabs) || (isInsideTabs && roleModel?.canDelete)) && !props.parentId && (
            <Button
              className={componentStyles.actionTableButton}
              onClick={() => actions.delete(props)}
              variant="outline-danger"
            >
              Удалить
            </Button>
            )}
          </TableAction>)
          : <React.Fragment/>)
      }
    </div>
  )
}
